// クエリを扱うサービスです。
// TODO ちょっと汚くなってきているのでリファクタリングする

import Vue from 'vue'
import repository from '@/repositories/Repository'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.longQuery) this.$longQuery = options.longQuery
    else if (options.parent && options.parent.$longQuery)
      this.$longQuery = options.parent.$longQuery
  },
})

export default {
  /**
   * クエリを実行する
   *
   * 送信データにフォーマット不正等がなければ受付完了として即時レスポンスがあります。
   *
   * TODO フォーマット不正でエラーとなった場合の対処。
   */
  async executeQuery(resourceName, postData) {
    const response = await repository.mouse.post(
      `/api/download_requests`,
      postData,
    )
    return response.data
  },
}
